export const DEFAULT_ROUTE = "/dashboard";
export const MINUTES_SIGN = "min";
export const BILLIONS_SIGN = "mld";
export const MILLIONS_SIGN = "mil";
export const THOUSANDS_SIGN = "tis";
export const EMPTY_DETAIL_FIELD = "";
export const CIRCLE_SIGN = "•";
export const DOT_SEPARATOR = " · ";
export const ARROW_DOWN_SIGN = "↓";
export const ARROW_UP_SIGN = "↑";
export const LIST_ICON_SIZE = 32;

export const GRASS_GREEN_MYPLANN = "#0C8926";
export const BLOOD_RED_MYPLANN = "#DC2626";
export const LIGHT_GREEN_MYPLANN = "#D9FFE0";
export const LIGHT_BLUE_MYPLANN = "#2789E3";

export const SUCCESS_MYPLANN_LIGHT = "#0AAB2A";
export const SUCCESS_MYPLANN_DARK = "#3EEA60";

export const DANGER_MYPLANN_LIGHT = "#EF4444";
export const DANGER_MYPLANN_DARK = "#F87171";
export const DANGER_TERTIARY = "#FEF3F2";

export const FINANCES_INCOME_GREEN = "#409959";
export const FINANCES_EXPENSES_RED = "#F9785F";

export const BAR_MYPLANN_LIGHT = "#FAFAFA";
